import { h as l } from "vue";
import d from "./ghl-ui.es372.js";
const s = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  padding: "8px 0",
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  flexDirection: "column"
}, r = {
  margin: 0,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  width: "100%"
}, i = (e) => l(
  "div",
  {
    style: s
  },
  [
    l(
      "p",
      {
        style: r
      },
      { default: () => e == null ? void 0 : e.label }
    ),
    l(
      "span",
      {
        style: {
          color: e.disabled ? "var(--gray-300)" : "var(--gray-500)",
          ...r
        }
      },
      {
        default: () => e != null && e.description ? e == null ? void 0 : e.description : void 0
      }
    )
  ]
), g = ({ option: e }) => e.label, f = ({
  option: e,
  handleClose: a
}) => l(
  d,
  {
    closable: !0,
    onClose: (t) => {
      t.stopPropagation(), a();
    }
  },
  {
    default: () => e.label
  }
);
export {
  i as defaultRenderLabel,
  f as renderMultipleSelectTag,
  g as renderSingleSelectTag
};
